import React from "react";
import { Table } from "antd";
import "../../styles/table.css";

function TableComponent(props) {
  return (
    <div className={props.wrapClassName}>
      <Table
        className={props.className}
        style={props.style}
        size={props.size}
        tableLayout={props.tableLayout ?? "fixed"}
        dataSource={props.data}
        columns={props.columns}
        pagination={{
          defaultPageSize: props.pageSize,
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "30"],
        }}
        expandable={{ defaultExpandAllRows: false }}
        rowKey={props.rowKey}
        loading={props.loading}
        scroll={props.scroll}
        onRow={(record, rowIndex) => {
          return {
            onClick: () => {
              if (props.clickTableRow) {
                props.clickTableRow(record);
              } else {
                console.log("No click event handler provided");
              }
            },
          };
        }}
        onChange={props.onChange}
      ></Table>
    </div>
  );
}

export default TableComponent;
